import type { WidgetConfig } from '../config/schema';

interface UseEndpointConfigOptions {
  config: WidgetConfig;
}

/** Endpoint, analytics and telemetry values, read from the canonical config. */
export function useEndpointConfig({ config }: UseEndpointConfigOptions) {
  const { endpoints, analytics, telemetry, security, commerce } = config;
  return {
    widgetAuthToken: security.widgetAuthToken,
    messageEndpoint: endpoints.messageEndpoint,
    messageCreateEndpoint: endpoints.messageCreateEndpoint,
    streamEndpoint: endpoints.streamEndpoint,
    threadEndpoint: endpoints.threadEndpoint,
    threadCreateEndpoint: endpoints.threadCreateEndpoint,
    threadUpdateEndpoint: endpoints.threadUpdateEndpoint,
    threadDeleteEndpoint: endpoints.threadDeleteEndpoint,
    cartEndpoint: endpoints.cartEndpoint,
    cartAttributionEndpoint: endpoints.cartAttributionEndpoint,
    feedbackEndpoint: endpoints.feedbackEndpoint,
    cartMode: commerce.cartMode,
    analyticsBaseUrl: analytics.baseUrl,
    analyticsEndpoint: analytics.endpoint,
    analyticsSampleRate: analytics.sampleRate,
    analyticsEnabled: analytics.enabled,
    analyticsApiKey: analytics.apiKey,
    telemetryEnabled: telemetry.enabled,
    telemetryPollIntervalMs: telemetry.pollIntervalMs,
    telemetryShowContext: telemetry.showContext,
    telemetryEndpoint: telemetry.endpoint,
  };
}
